import React, { useEffect } from "react";
import "./ScrollImg.css";

import n1 from "../../Assets/project13/n1.webp";
import n2 from "../../Assets/project13/n2.webp";
import n3 from "../../Assets/project13/n3.webp";
import n4 from "../../Assets/project13/n4.webp";
import n5 from "../../Assets/project13/n5.webp";
import n6 from "../../Assets/project13/n6.webp";
import n7 from "../../Assets/project13/n7.webp";


const ScrollImg13 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  
  const images = [n1, n2, n3, n4, n5, n6, n7];


  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg13;
